<div mdbModal #commonDeleteModal="mdbModal" class="modal fade top" id="commonDeleteModal" tabindex="-1" role="dialog"
  aria-labelledby="commonDeleteModal" aria-hidden="true" style="z-index:1051 ">
  <div class="modal-dialog modal-notify modal-danger" role="document">
    <!--Content-->
    <div class="modal-content">
      <app-spinner [isLoading]="isLoading"></app-spinner>
      <!--Header-->
      <div class="modal-header danger-color-dark">
        <p class="heading lead">
          {{ commonDeleteHeading && commonDeleteHeading != '' ? commonDeleteHeading : 'administration_deleteConfirmation_label' | translate }}
        </p>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="commonDeleteModal.hide()">
          <span aria-hidden="true" class="white-text">&times;</span>
        </button>
      </div>

      <!--Body-->
      <div class="modal-body">
        <div class="text-center">
          <mdb-icon fas icon="check" size="4x" class="mb-3 animated rotateIn"></mdb-icon>
          <p>{{ commonDeleteMessage }}</p>
          <p class="text-muted">{{ deleteItem?.name }}</p>
        </div>
      </div>

      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <a type="button" mdbBtn size="sm" class="waves-effect danger-color-dark" mdbWavesEffect
          (click)="confirmDelete(true)">{{'BTN_confirm_label' | translate }}
        </a>
        <a type="button" mdbBtn color="danger" size="sm" outline="true" class="waves-effect" mdbWavesEffect
          (click)="confirmDelete(false)">{{'BTN_cancel_label' | translate }}</a>
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>
